import { produce } from 'immer';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { Modal, ModalType } from '@/components/modal/Modal.type';

export type ModalPosition = 'default' | 'outOfChat';
interface ModalState {
  modals: Modal[];
  modalsOutOfChat: Modal[];
  openModal: (modal: Modal, pos: ModalPosition) => void;
  closeModal: (type: ModalType, pos: ModalPosition) => void;
  closeAllModal: () => void;
}

const useModalStore = create<ModalState>()(
  devtools(
    (set, get) => ({
      modals: [],
      modalsOutOfChat: [],
      openModal: (modal, pos) => {
        const isDefault = pos === 'default';
        const modals = isDefault ? get().modals : get().modalsOutOfChat;

        const isOpened = modals.some((openedModal) => openedModal.type === modal.type);
        if (isOpened) {
          return;
        }

        return set(
          produce((draft: ModalState) => {
            if (isDefault) {
              draft.modals = [...draft.modals, modal];
            }

            if (!isDefault) {
              draft.modalsOutOfChat = [...draft.modalsOutOfChat, modal];
            }
          }),
        );
      },
      closeModal: (type, pos) => {
        const isDefault = pos === 'default';
        const modals = isDefault ? get().modals : get().modalsOutOfChat;

        const filteredModal = modals.filter((modal) => modal.type !== type);

        return set(
          produce((draft: ModalState) => {
            if (isDefault) {
              draft.modals = filteredModal;
            }
            if (!isDefault) {
              draft.modalsOutOfChat = filteredModal;
            }
          }),
        );
      },
      closeAllModal: () =>
        set(() => ({
          modals: [],
          modalsOutOfChat: [],
        })),
    }),
    {
      name: 'modal',
    },
  ),
);

export default useModalStore;
